import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const COMPONENT_LOADER_REF = new InjectionToken('COMPONENT_LOADER_REF');

@Component({
    selector: 'icc-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
    error = '';
    errorTimer: number | null = null;
    errorCtx = {
        time: 0,
        get timeLeft() {
            return this.time > 0 ? this.time + ' s' : this.translateService.instant('INTERFACE|(Jeszcze chwilę...)');
        }
    };
    generalError: boolean;

    constructor(@Inject(COMPONENT_LOADER_REF) private loaderRef: {
        cancel: () => void;
    }, private translateService: TranslateService) {}

    cancel() {
        this.loaderRef.cancel();
    }

    refresh() {
        this.loaderRef.cancel();
        window.location.reload();
    }

    setError(error: string, timeLeft = 3) {
        this.error = error;
        this.errorCtx.time = timeLeft;
        if (this.generalError || error === 'TIMEOUT' || error === 'NO_ACCESS' || error === 'SYNC_ERROR') {
            this.startErrorTimer();
        }
    }

    private startErrorTimer() {
        this.errorTimer = window.setInterval(() => {
            this.errorCtx.time--;
            if (this.errorCtx.time <= 0) {
                window.clearInterval(this.errorTimer);
                this.errorTimer = null;
            }
        }, 1000);
    }

    clearError() {
        this.error = '';
        this.errorCtx.time = 0;
        if (this.errorTimer) {
            window.clearInterval(this.errorTimer);
            this.errorTimer = null;
        }
    }

    showGeneralError() {
        this.generalError = true;
        if (this.errorCtx.time > 0 && !this.errorTimer) {
            this.startErrorTimer();
        }
    }
}
